import { getExperimentTreatment as getExperimentTreatmentSelector } from '@ms/yammer-data/dist/domains/experiments/selectors';
import type { Experiment } from '@ms/yammer-data/dist/state/types';
import { useCurrentLocale } from '@ms/yammer-i18n-react';
import { useRelayContext } from '@ms/yammer-relay/dist/environment';
import { useCallback } from 'react';
import { useDispatch, useStore } from 'react-redux';

import type { PageDataLoadContextValue } from '../context';
import type { DataLoaderModule } from '../types';

type UsePreloadPageDataCallback = (
  setPageLoadContext: React.Dispatch<React.SetStateAction<PageDataLoadContextValue | undefined>>
) => (dataLoader: () => Promise<DataLoaderModule>, routeParams: Record<string, unknown>) => Promise<void>;
export const usePreloadPageDataCallback: UsePreloadPageDataCallback = (setPageLoadContext) => {
  const dispatch = useDispatch();
  const store = useStore();
  const { environment: relayEnvironmentPromise } = useRelayContext();
  const currentLocale = useCurrentLocale();

  const getExperimentTreatment = useCallback(
    // eslint-disable-next-line react-hooks/preserve-manual-memoization
    (experiment: Experiment) => getExperimentTreatmentSelector(store.getState(), experiment),
    // oxlint-disable-next-line react/exhaustive-deps
    []
  );

  return useCallback(
    async (dataLoader, routeParams) => {
      const { loadData } = await dataLoader();
      const data = await loadData({
        dispatch,
        relayEnvironmentPromise,
        routeParams,
        currentLocale,
        getExperimentTreatment,
      });

      if (data) {
        setPageLoadContext(data instanceof Error ? { pageLoadError: data } : { pageLoadData: data });
      }
    },
    [setPageLoadContext, relayEnvironmentPromise, dispatch, currentLocale, getExperimentTreatment]
  );
};
